var _templateObject, _templateObject2, _templateObject3, _templateObject4;

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

/* eslint-disable react/require-default-props */
import React from 'react';
import { node, string } from 'prop-types';
import styled from 'styled-components';
import cn from 'classnames';
import ToggleContext from '../toggleContext';
var ToggleSection = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: grid;\n  grid-template-columns: 11fr 1fr;\n  background-color: #f7f6f6;\n  border: 1px solid #cfd8dc;\n  border-left-width: 0px;\n  border-right-width: 0px;\n  border-bottom-width: 1px;\n  border-top-width: 0px;\n  border-bottom-color: #cfd8dc;\n  cursor: pointer;\n\n  &::-webkit-scrollbar {\n    width: 0 !important;\n  }\n"])));
ToggleSection.displayName = 'ToggleSection';
var ToggleText = styled.p(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  grid-column-start: 1;\n  grid-row-start: 1;\n  color: #827771;\n  font-family: Montserrat;\n  font-size: 22px;\n  font-stretch: normal;\n  font-style: normal;\n  font-weight: normal;\n  line-height: 1.36;\n  letter-spacing: normal;\n  margin-bottom: 0;\n  margin-top: 0;\n  padding-top: .5em;\n  padding-bottom: 1rem;\n  text-align: left;\n  pointer-events: none;\n\n  @media (max-width: 767px) {\n    font-size: 22px;\n    line-height: 30px;\n    text-align: left;\n  }\n"])));
ToggleText.displayName = 'ToggleText';
var ToggleIcon = styled.svg(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  align-self: center;\n  justify-self: right;\n  grid-column-start: 2;\n  grid-row-start: 1;\n  background-color: #f7f6f6;\n  fill: #827771;\n  height: 20px;\n  pointer-events: none;\n  margin-left: 16px;\n  width: 20px;\n"])));
ToggleIcon.displayName = 'TogglePlusIcon';
var CollapsibleContent = styled.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  background-color: #f7f6f6;\n  text-align: left;\n  grid-column-start: 1;\n  grid-column-end: 3;\n\n  &::-webkit-scrollbar {\n    width: 0 !important;\n  }\n"])));
CollapsibleContent.displayName = 'CollapsibleContent';
var plusIconPath = 'M30.2,50H19.8a1.06,1.06,0,0,1-1.05-1V31.25H1.05a1,1,0,0,1-.74-.31A1,1,0,0,1,0,30.2V19.8a1,1,0,0,1,.31-.74,1,1,0,0,1,.74-.31h17.7V1.05a1,1,0,0,1,.31-.74A1,1,0,0,1,19.8,0H30.2a1,1,0,0,1,.74.31,1,1,0,0,1,.31.74v17.7H49a1.06,1.06,0,0,1,1,1.05V30.2a1.06,1.06,0,0,1-1,1.05H31.25V49a1.06,1.06,0,0,1-1.05,1Z';
var minusIconPath = 'M49.44,12.62H1.06A1,1,0,0,1,0,11.56V1.06A1,1,0,0,1,.31.31,1,1,0,0,1,1.06,0H49.44a1,1,0,0,1,.75.31,1,1,0,0,1,.31.75v10.5a1,1,0,0,1-1.06,1.06Z';

function Toggle(_ref) {
  var text = _ref.text,
      children = _ref.children,
      dataAnalyticsLabel = _ref.dataAnalyticsLabel,
      className = _ref.className;
  return /*#__PURE__*/React.createElement(ToggleContext.Consumer, null, function (_ref2) {
    var isExpanded = _ref2.isExpanded,
        toggle = _ref2.toggle;
    return /*#__PURE__*/React.createElement(ToggleSection, {
      className: cn(className, 'toggle-section'),
      onClick: toggle,
      "data-analytics-label": dataAnalyticsLabel,
      "data-analytics-id": isExpanded ? 'expanded' : 'collapsed',
      key: text
    }, /*#__PURE__*/React.createElement(ToggleText, {
      className: "toggle-text"
    }, text), /*#__PURE__*/React.createElement(ToggleIcon, {
      role: "button",
      className: isExpanded ? 'toggle-collapsed-icon' : 'toggle-expanded-icon',
      viewBox: isExpanded ? '0 0 52 20' : '0 0 52 52',
      fill: "#827771",
      "data-test-id": isExpanded ? 'toggle-collapsed-icon' : 'toggle-expanded-icon'
    }, /*#__PURE__*/React.createElement("title", null, isExpanded ? 'icon to collapse content' : 'icon to open content'), /*#__PURE__*/React.createElement("path", {
      d: isExpanded ? minusIconPath : plusIconPath
    })), isExpanded && /*#__PURE__*/React.createElement(CollapsibleContent, {
      className: isExpanded ? 'collapsed-content-visible' : 'collapsed-content-hidden'
    }, children));
  });
}

Toggle.propTypes = {
  text: string.isRequired,
  children: node.isRequired,
  dataAnalyticsLabel: string,
  className: string
};
export default Toggle;